const searchbarSelector = (state) => state?.searchbar;

export {searchbarSelector};
